import FlightOutlinedIcon from '@mui/icons-material/FlightOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import type { CurrentUser } from '../../api/types/auth';
import AirlineStatsPage from './pages/AirlineStatsPage';

/** `GET /api/airlinestats` — an API-key-gated ops report, no legacy MVC equivalent.
 *  Master GSA only; grouped under "Raporlar" alongside the sales reports. */
const isVisible = (user: CurrentUser | null) => !!user?.isMasterGsa;

export const airlineStatsModule: ModuleDefinition = {
  routes: [{ path: 'airline-stats', element: <AirlineStatsPage /> }],
  menuItems: [
    {
      label: 'Havayolu İstatistikleri',
      path: 'airline-stats',
      icon: <FlightOutlinedIcon />,
      group: 'Raporlar',
      groupIcon: <AssessmentOutlinedIcon />,
      isVisible,
    },
  ],
};
